import * as CONSTANTS from 'constants';

export const fetchSearchResults = (keyword) => {
    return {
        type: CONSTANTS.FETCH_SEARCH_RESULTS,
        payload: {
            url: '/search/all/global/',
            data: {
                keyword
            }
        }
    };
};

export const setSearchResults = (data) => {
    return {
        type: CONSTANTS.SET_SEARCH_RESULTS,
        payload: data
    };
};

export const fetchSearchDevices = (keyword) => {
    return {
        type: CONSTANTS.FETCH_SEARCH_DEVICES,
        payload: {
            url: '/search/all/device/',
            data: {
                keyword
            }
        }
    };
};
export const fetchSearchDeviceHistory = (searchValue = '', startDate = null, endDate = null) => {
    return {
        type: CONSTANTS.FETCH_SEARCH_DEVICE_HISTORY,
        payload: {
            url: '/support/search/device/versionhistory/',
            data: {
                searchValue,
                startDate,
                endDate
            }
        }
    }
}

export const fetchSearchGateways = (keyword) => {
    return {
        type: CONSTANTS.FETCH_SEARCH_GATEWAYS,
        payload: {
            url: '/search/all/gateway/',
            data: {
                keyword
            }
        }
    };
};

export const setSearchDevicesOrGateways = (data) => {
    return {
        type: CONSTANTS.SET_SEARCH_DEVICES_OR_GATEWAYS,
        payload: data
    };
};

export const setSearchDeviceHistory = (data) => {
    return {
        type: CONSTANTS.SET_SEARCH_DEVICE_HISTORY,
        payload: data
    };
};

export const fetchSearchResultsError = (errorID = 0) => {
    if (!isNaN(Number(errorID))) {
        return {
            type: CONSTANTS.FETCH_SEARCH_RESULTS_ERROR,
            payload: {
                url: '/error/search/',
                data: {
                    errorID: Number(errorID)
                }
            }
        };
    }
};

export const setSearchResultsError = (data) => {
    return {
        type: CONSTANTS.SET_SEARCH_RESULTS_ERROR,
        payload: data
    };
};

export const fetchAllSearchErrors = ({minutes = 0, page = 1}) => {
    return {
        type: CONSTANTS.FETCH_ALL_SEARCH_ERRORS,
        payload: {
            url: '/error/search/all/',
            data: {
                offset: page === 0 ? 0 : page === 1 ? 0 : (page - 1) * 100,
                limit: 100,
                minutes: minutes
            },
            page
        }
    };
};

export const setAllSearchErrors = (data) => {
    return {
        type: CONSTANTS.SET_ALL_SEARCH_ERRORS,
        payload: data
    };
};


export const setErrorStats = (data) => {
    return {
        type: CONSTANTS.SET_ERROR_STATS,
        payload: data
    };
};

export const setErrorStatDetails = (data) => {
    return {
        type: CONSTANTS.SET_ERROR_STAT_DETAILS,
        payload: data
    };
};

export const setErrorClaims = (data) => {
    return {
        type: CONSTANTS.SET_ERROR_CLAIMS,
        payload: data
    };
};

export const setErrorTimeSpan = (data) => {
    return {
        type: CONSTANTS.SET_ERROR_TIMESPAN,
        payload: data
    };
};

export const setErrorHeader = (data) => {
    return {
        type: CONSTANTS.SET_ERROR_HEADER,
        payload: data
    };
};

export const fetchUserVersionHistory = (searchValue = '', startDate = null, endDate = null) => {
    return {
        type: CONSTANTS.FETCH_USER_VERSION_HISTORY,
        payload: {
            url: '/support/search/user/appversionhistory/',
            data: {
                searchValue,
                startDate,
                endDate
            }
        }
    };
};
export const setUserVersionHistory = (data) => {
    return {
        type: CONSTANTS.SET_USER_VERSION_HISTORY,
        payload: data
    };
};
